import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_ADMIN_ARTICLES = Symbol('admin.articles');
export const TRANSLATION_GROUP_AFFILIATE_ARTICLES = Symbol('affiliate.articles');

export const ADMIN_ARTICLES_ROUTE_NAME = Symbol('admin.articles');
export const ADMIN_ARTICLES_LIST_ROUTE_NAME = Symbol('admin.articles.list');
export const AFFILIATE_ARTICLES_ROUTE_NAME = Symbol('affiliate.articles');
export const AFFILIATE_ARTICLES_LIST_ROUTE_NAME = Symbol('affiliate.articles.list');

export const ARTICLES_LIST_URL = ':namespace/articles/list';
export const ARTICLES_LIST_QUERY_KEY = 'articles.list';

export const ARTICLES_GET_URL = ':namespace/articles/:id';
export const ARTICLES_GET_QUERY_KEY = ':namespace/articles/:id';

export const ARTICLES_LOCALE_ALL = 'locales.all';

export const ARTICLES_DELETE_URL = 'admin/articles/:id';
export const ARTICLES_DELETE_MUTATION_KEY = 'articles.delete';

export const ARTICLES_PERMISSIONS = {
  SHOW: new Permission(
    PermissionsList.admin.ARTICLES_SHOW,
    PermissionsList.affiliate.ARTICLES_SHOW,
  ),
  CREATE: new Permission(PermissionsList.admin.ARTICLES_CREATE),
  DESTROY: new Permission(PermissionsList.admin.ARTICLES_DESTROY),
  UPDATE: new Permission(PermissionsList.admin.ARTICLES_UPDATE),
};
